import { v4 as uuidv4 } from 'uuid';

export function Video(props = {}, childrenComponents = []) {
	return {
		componentName: 'Video',
		componentId: uuidv4(),
		title: '',
		props: Object.assign(
			{
				name: '',
				description: '',
				src: 'https://www.youtube.com/watch?v=8-KpLN57wOc',
				type: '',
				poster: '',
				controlsType: '',
				autoPlay: false,
				muted: false,
				loop: false,
				playsInline: false,
				width: '100%',
				height: 'auto',
				PlayIcon: '',
				PauseIcon: '',
				VolumeOnIcon: '',
				VolumeOffIcon: '',
				FullscreenIcon: '',
				blockClass: 'video',
			},
			props,
		),
		childrenComponents,
	};
}
